import { Controller } from '@hotwired/stimulus';
import { useIntersection } from 'stimulus-library/dist';

export default class extends Controller {
  initialize() {
  }

  connect() {
    useIntersection(this, this.element, this.appear, this.disappear);
  }

  appear() {
    // if requestSubmit is not defined
    if (typeof this.element.requestSubmit === 'function') {
      this.element.requestSubmit();
    } else {
      this.element.submit();
    }
  }

  disappear() {
  }
}
